import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import { GET_CHATS_PRIVATE, ADD_CHAT_TO_PRIVATE_THREAD, CREATE_NEW_PRIVATE_THREAD, SET_INBOX } from '../../Actions/Chat'
import { REMOVE_MESSAGE } from '../../Actions/Wazzup'
import { GiftedChat } from 'react-gifted-chat';
import Bubble from '../../Components/Chat/Bubble'
import Composer from '../../Components/Chat/Composer'
import Lightbox from '../../Components/Lightbox/Index'
import Sidebar from '../../Components/Sidebar/Index.js'
import { MERCURE_URL } from '../../config'
import { BubbleIcon, CloseIcon, RemoveIcon } from '../../Svg/Index.js'
import { SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import Loader from '../../Components/Loader/Index.js'


class Chat extends Component {

    state = {
		messages: [],
		isNewChat: false,
        threadId: null,
        chatLoading: false,
        dialogActive: false,
        removingMessage: null,
	}


    UNSAFE_componentWillMount() {
        const { threadId, newChat } = this.props.location

        this.setState({
            chatLoading: true
        })

		if(newChat) {
			this.setState({
                isNewChat: true,
                chatLoading: false
            })
		} else {
			this.setState({
				threadId: threadId
			}, () => {
				this.props.actions.GET_CHATS_PRIVATE(this.state.threadId).then(data => {
					this.setState({
						messages: data.map(r => {
							r.user.avatar = r.user.avatar.user_avatar
							if(r.image) {
								r.image = r.image.message_medium
							}
							return r
                        }),
                        chatLoading: false
                    }, () => {
                        document.querySelectorAll('.o-web-container')[0].scrollTo(0, document.querySelectorAll('.o-web-container')[0].scrollHeight + 200)
                        window.scrollTo(0, document.documentElement.scrollHeight + 200)
                    });

				})
			})
		}
    }

    componentDidMount() {
        const { isNewChat } = this.state
		let { user } = this.props.location

		if(!isNewChat) {
			this.addMercureListener()
        }
        
        if(user) {
            this.props.actions.SET_PROFILE_OPEN(false);
        }

    }

    componentWillUnmount() {
        if(this.eventSource) {
		    this.eventSource.removeEventListener('message', this.handleMercure)
            this.eventSource.close();
        }
	}

    addMercureListener() {
		const LISTEN_URL = `${MERCURE_URL}?topic=https://jongenout.nl/threads/${encodeURIComponent(this.state.threadId)}`
		this.eventSource = new EventSource(LISTEN_URL);
		this.eventSource.addEventListener('message', this.handleMercure)
	}

    handleMercure = (event) => {
		let message = JSON.parse(event.data)
		if(!message.type) {
			message.user.avatar = message.user.avatar.user_avatar
			if(message.image) {
				message.image = message.image.message_medium
			}
			this.setState({
				messages: [message, ...this.state.messages]
			})
		} else {
			this.setState({
				messages: this.state.messages.filter((item)=> {
					return item._id !== message.id
				})
			})
		}
    
        document.querySelectorAll('.o-web-container')[0].scrollTo(0, document.querySelectorAll('.o-web-container')[0].scrollHeight + 200)
        window.scrollTo(0, document.documentElement.scrollHeight + 200)

    }
    
    initNewChat(composer, user) {
		//Create new thread
		this.props.actions.CREATE_NEW_PRIVATE_THREAD(composer, user).then(r => {
			//Add first message to empty messages state
			this.setState({
				isNewChat: false,
				threadId: r._uuid,
				messages: r.messages.map(m => {
					m.user.avatar = m.user.avatar.user_avatar
					if(m.image) {
						m.image = m.image.message_medium
					}
					return m
				})
			}, () => {
				//Init listener
                this.addMercureListener()
			})
		})
	}
    
    postToServer = (props) => {
		let { user } = this.props.location
		const { threadId, isNewChat } = this.state
		
		if(isNewChat) {
			this.initNewChat(this.props.composer, user)
		} else {
			this.props.actions.ADD_CHAT_TO_PRIVATE_THREAD(this.props.composer, threadId)
		}
	}

    handlePopupSource = (source) => {
        this.setState({
            popupSource: source,
            popupOpen: true
        });
    }

    handlePopupClose = () => {
        this.setState({
            popupSource: null,
            popupOpen: false
        });
    }

    openProfile = (props)=> {
        if(!props) return;
        if(props.roles.includes("ROLE_ANONYMOUS")) return;

        this.props.actions.SET_PROFILE_OPEN(props._id)
        document.body.classList.add('sidebar-open');
    }

    handleRemoveDialog = (id) => {
        this.setState({
            dialogActive: true,
            removingMessage: id
        })        
    }

    handleMessageRemove = () => {
        this.setState({
            dialogActive: false
        })
        this.props.actions.REMOVE_MESSAGE(this.state.removingMessage).then(()=> {

        })
    }

    render() {
        const { user } = this.props;
        const { messages, popupOpen, popupSource, chatLoading, dialogActive } = this.state;
        let isBlocked = false;

        if(this.props.location.user) {
            if(this.props.user.blocked_users) {
                isBlocked = !!this.props.user.blocked_users.filter(r => r._id === this.props.location.user._id).length
            }
        }

        return (
            <>
                <Lightbox active={popupOpen} source={popupSource} handleLightboxClose={this.handlePopupClose} />

                

                {
                    chatLoading && (
                        <Loader />
                    )
                }

                <div className="o-page-wrap">
                    
                    <Sidebar />

                    

                    <div className="o-main-container o-main-container--alt">
                    
                        <div className="c-fixed-back-btn-wrapper">
                            <Link to="/messages" className="c-bare-btn c-fixed-back-btn c-btn c-btn--with-icon">
                                <CloseIcon />
                            </Link>
                        </div>

                        {
                            dialogActive && (
                                <div className="c-dialog">
                                    <div className="c-dialog__inner">
                                        <h2>Wil je dit bericht verwijderen?</h2>
                                        <button className="c-btn c-btn--primary" onClick={this.handleMessageRemove}>Ja, verwijder</button>
                                        <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                                    </div>
                                </div>
                            )
                        }
                        
                        <div className="c-chat">
                            {
                                this.props.location.user && (
                                    <button className="c-chat__other-person c-bare-btn" onClick={ ()=> this.openProfile(this.props.location.user)} style={{backgroundImage: `url('${this.props.location.user.avatar.user_avatar}')`}}>
                                        <span>{this.props.location.user.display_name}</span>
                                    </button>
                                )
                            }
                            <GiftedChat
                                locale="nl"
                                messages={messages}
                                showUserAvatar
                                showAvatarForEveryMessage
                                placeholder={`Typ hier je bericht...`}
                                onPressAvatar={(props)=> this.openProfile(props)}
                                renderBubble={props => {
                                    return (
                                        <div className={`c-bubble ${props.currentMessage.user._id === user._id ? 'c-bubble--alt' : ''}`}>
                                            <span className="c-bubble__label">{props.currentMessage.user.display_name}</span>
                                            <span className="c-bubble__remove" onClick={() => this.handleRemoveDialog(props.currentMessage._id)}><RemoveIcon /></span>
                                            <div className="c-bubble__inner">
                                                <Bubble {...props} handleLightboxOpen={this.handlePopupSource} />
                                                <span className="c-bubble__icon">
                                                    <BubbleIcon />
                                                </span>
                                            </div>
                                        </div>
                                    )
                                }}
                                renderInputToolbar={() => null}
						        renderComposer={() => null}
                                user={{
                                    _id: user._id,
                                    name: user.display_name,
                                    avatar: user.avatar.user_avatar,
                                }}
                                onSend={this.postToServer}
                            />
                            {
                                !isBlocked && (
                                    <Composer handleSend={this.postToServer} />
                                )
                            }
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
        composer: state.composer.composer,
		messages: state.chat.messages,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_INBOX, ADD_CHAT_TO_PRIVATE_THREAD, GET_CHATS_PRIVATE, CREATE_NEW_PRIVATE_THREAD, SET_PROFILE_OPEN, REMOVE_MESSAGE}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Chat))